import React, { Component } from 'react'
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Divider from '@mui/material/Divider';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab'
import { GradientButton } from '../GradientButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import Stack from '@mui/material/Stack';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import Slider from '@mui/material/Slider';
import "../../../styles/components.css"
import { getURLBase ,updateHeightAfterContentUpdate} from '../../../utils/helperFns';
import axios from 'axios';
import LoaderBlock from "../../ui-components/LoaderBlock";
import AppleIcon from "../../../images/Apple logo 1.svg";
import TeslaIcon from "../../../images/Tesla 1.svg";
import PfizerIcon from "../../../images/Pfizer-uk-logo-open-graph 1.svg";
import MKIcon from "../../../images/M&S 1.svg";
import BPIcon from "../../../images/BP 1.svg";

const images = {
    AppleIcon: AppleIcon,
    TeslaIcon: TeslaIcon,
    PfizerIcon: PfizerIcon,
    MKIcon: MKIcon,
    BPIcon: BPIcon
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export class StocksandEFTs extends Component {
    constructor(props) {
        super(props)
        this.url = getURLBase(true) + "/investstocks"
        this.state = {
            value: 0,
            isReady:false,
            stockSelected: 0,
            investingTotal:0,
            savingsTotal:250,
            stocksData: []
        }
    }

    componentDidMount() {
        //backend call to get the stock details
        axios.post(this.url, { gid: this.props.gid }).then(
            (response) => {
                this.setState(response.data.body)
                this.setState({
                    isReady:true,
                    stockSelected: this.state.stocksData[0].stocksList[0].title
                })
            }
        )
    }

    handleTabChange = (event, newValue) => {
        this.setState({
            value: newValue,
            stockSelected: this.state.stocksData[newValue].stocksList[0].title
        })
    };

    handleRadioChange = (event) => {
        this.setState({
            stockSelected: event.target.value
        });
    };

     handleInvestSlider = (event, newValue) => {
        if (typeof newValue === 'number') {
          this.setState({
              investingTotal: newValue
          })
        }
      };

    render() {
        return (
            <Card className="popup" id="child_StocksandEFTs">
                <Box className="popupClose">
                    <IconButton aria-label="Close" onClick={this.props.toggleHandler}>
                        <ArrowBackIcon />
                    </IconButton>
                </Box>
                <Box className="popupHeader">
                <Typography variant="h4" align="center" gutterBottom>Stocks and EFTs</Typography>
                <Divider light />
                </Box>
                <Box className="popupBody" pt={{xs:8,sm:0}}>
                <CardContent textAlign="center" sx={{ paddingTop: 0 }}>
                    {
                        this.state.isReady ? <Box sx={{ width: '100%' }}>

                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={this.state.value}
                                onChange={this.handleTabChange}
                                variant="scrollable"
                                scrollButtons="auto"
                                aria-label="efts and stocks list"
                                // variant="fullWidth"
                                >
                                {this.state.stocksData.map((item, index) => (
                                    <Tab key={`stocktab-${index}`} label={item.title} {...a11yProps(index)} />
                                ))}
                            </Tabs>
                        </Box>
                        <Box mt={1}>
                            {this.state.isReady && this.state.stocksData.map((stockType, index) => (
                                <TabPanel value={this.state.value} index={index}>
                                    <Typography
                                        variant="h6" align="center" marginBottom={4}>
                                        {stockType.title}
                                    </Typography>

                                    {stockType.stocksList.map((key, i) => (
                                        <RadioGroup
                                            aria-label="stocks"
                                            value={this.state.stockSelected}
                                            onChange={this.handleRadioChange}
                                            name="radio-buttons-group"
                                        >
                                            <Grid sx={{ borderBottom: 1, borderColor: 'divider' }} container key={`singleStock-${i}`} marginY={0.8} columnSpacing={2} maxWidth={420} marginX="auto">
                                                <Grid item xs={1} justifyContent="center">
                                                    <FormControlLabel value={key.title} control={<Radio />} label="" />
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Stack direction="row" spacing={2}>
                                                        <img src={images[key.icon]} className="stockIcon" alt=""/>
                                                        <Stack>
                                                            <Typography variant="body1" fontWeight={700}>
                                                                {key.title}
                                                            </Typography>

                                                            <Typography variant="caption" fontWeight={700} color="text.secondary">
                                                                {key.keyword}
                                                            </Typography>
                                                        </Stack>
                                                    </Stack>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Stack spacing={1}>
                                                        <Typography variant="body1" fontWeight={700}>
                                                            <Typography variant="caption" color="text.secondary" marginRight="4px" fontWeight={800}>
                                                                {key.currency}
                                                            </Typography>
                                                            {key.price}
                                                        </Typography>
                                                        <Typography variant="body2" fontWeight={700} display="flex" alignItems="center">
                                                            {
                                                                key.priceChangePercentage > 0 ?
                                                                    <ArrowDropUpIcon color="primary" sx={{ fontSize: 50, height: 24, width: 24 }} /> :
                                                                    <ArrowDropDownIcon color="error" sx={{ fontSize: 50, height: 24, width: 24 }} />
                                                            }

                                                            {Math.abs(key.priceChangePercentage)}
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                                <Grid item xs={4} justifyContent="end">
                                                    {this.state.stockSelected === key.title ?
                                                        <Typography textAlign="right" variant="h5" color="text.primary">
                                                            {key.stocksAmount} <Typography fontWeight="800" variant="subtitle2" color="text.secondary"> stocks </Typography>
                                                        </Typography> : ""
                                                    }
                                                </Grid>

                                            </Grid>
                                        </RadioGroup>
                                    ))}
                                </TabPanel>
                            ))}

                            <Box textAlign="center">
                                <GradientButton textTransformtype="capitalize" sx={{ marginX: "auto", marginBottom: "1rem", fontWeight: "800" }}>
                                    Invest
                                </GradientButton>
                            </Box>


                            <Grid container maxWidth={420} marginX="auto" justifyContent="space-between">
                                <Stack textAlign="center">
                                    <Typography variant="h5">
                                        €
                                        {this.state.savingsTotal}
                                    </Typography>
                                    <Typography variant="subtitle2" fontWeight="700" color="text.secondary">
                                        Investment Envelope Savings
                                    </Typography>
                                </Stack>

                                <Stack textAlign="center">
                                    <Typography variant="h5">
                                        €
                                        {this.state.investingTotal}
                                    </Typography>
                                    <Typography variant="subtitle2" fontWeight="700" color="text.secondary">
                                        Invest
                                    </Typography>
                                </Stack>
                            </Grid>


                            <Box maxWidth={420} marginTop={4} marginX="auto">
                            <Slider className="thumbSizeBig" max={this.state.savingsTotal} defaultValue={this.state.investingTotal} aria-label="Default" valueLabelDisplay="auto" onChange={this.handleInvestSlider} />
                            </Box>
                        </Box>

                    </Box> : <LoaderBlock />
                    }
                    
                </CardContent>
                {this.props.grandparentExist? updateHeightAfterContentUpdate("child_InvestmentsEnvelope", "child_StocksandEFTs", "parent_SavingEnvelopes"):
                updateHeightAfterContentUpdate("parent_TotalInvestments", "child_StocksandEFTs")}
</Box>
            </Card>
        );
    }
}

export default StocksandEFTs
